import { useQuery } from '@tanstack/react-query';
import {
  Appointment,
  AppointmentScheduledNotification,
  AppointmentSentNotification,
  AppointmentNotificationPreference,
} from 'src/models';
import { api } from 'src/services/api';
import { UseQueryOverrideOptions } from '../common';

export type UseGetAppointmentNotificationsParams = {
  appointment_id: Appointment['appointment_id'];
};

export type GetAppointmentNotificationsResponse = {
  practitioner_preference: AppointmentNotificationPreference[];
  schedulded_notifications: AppointmentScheduledNotification[];
  sent_notifications: AppointmentSentNotification[];
};

export const useGetAppointmentNotifications = (
  params: UseGetAppointmentNotificationsParams,
  options: UseQueryOverrideOptions = {}
) => {
  const { appointment_id } = params;
  return useQuery({
    enabled: !!appointment_id,
    ...options,
    queryKey: ['appointmentNotifications', appointment_id],
    queryFn: () =>
      api
        .post<GetAppointmentNotificationsResponse>(
          '/appointment_notifications',
          { appointment_id }
        )
        .then((res) => res.data),
  });
};
